import {UserType} from "data/types";

const SubscriptionTicket = ({
  subscriberImg,
  locality,
  numberSeat,
}: {
  subscriberImg: string;
  locality: string;
  numberSeat: string;
}) => {
  const userData = localStorage.getItem("user");
  let user: UserType;
  if (userData) {
    user = JSON.parse(userData) as UserType;
  }
  return (
    <div className="flex flex-col items-center w-80 bg-white dark:bg-neutral-900 rounded-3xl mx-auto p-4 shadow-lg">
      <div className="self-start flex items-center space-x-3 mb-4">
        <img
          className="w-12 h-12 rounded-full border-2 border-gray-200 dark:border-neutral-700 object-cover"
          src={user!.img}
          alt="subscriber"
        />
        <p className="font-medium text-sm text-neutral-800 dark:text-neutral-200">
          {user!.name}
        </p>
      </div>

      <div className="flex justify-center p-4 bg-gray-50 dark:bg-neutral-800 rounded-2xl shadow-inner">
        <img
          className="w-48 h-48 rounded-lg object-cover"
          src={subscriberImg}
          alt="QR Code"
        />
      </div>

      <p className="text-center mt-4 text-sm text-neutral-600 dark:text-neutral-400">
        {locality}
      </p>

      <p className="text-center mt-4 text-sm text-neutral-600 dark:text-neutral-400">
        {numberSeat === "0_0" ? "" : `Asiento: ${numberSeat}`}
      </p>
    </div>
  );
};

export default SubscriptionTicket;
